export function normalizeLegacyAlarmSettings(settings) {
  if (settings == null) return settings;
  const { event_alarms, offset_alarms, ...legacySettings } = settings;
  return legacySettings;
}
